
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/3catinfo/missatgeria",
      function () {
        return require("private-next-pages/3catinfo/missatgeria/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/3catinfo/missatgeria"])
      });
    }
  